/*
 * MC MEGA TABS — sidebar-tab switching for the desktop mega menu.
 * Custom element <mc-mega-tabs>. Vanilla, no libs. Desktop only (the element
 * only exists inside .header__link-list, which is display:none below 1150px).
 *
 * Scope: ONLY swaps which tile grid is visible. The panel open/close, hover-intent,
 * Esc/click-outside and fade-in are handled by the theme's existing
 * <details is="mega-menu-disclosure"> (MegaMenuDisclosure). This file never touches
 * NavigationDrawer / BaseCarousel / EffectCarousel or any shared theme code.
 */
/*
 * MC NAV INTENT — evita que un item vecino te robe el panel al rozarlo de paso.
 *
 * El theme abre el mega menú en cuanto el ratón toca el item, sin retardo
 * (DropdownDisclosure._detectHover -> this.open = true), y al abrir uno cierra los hermanos
 * (_transition -> openSiblings.forEach(s => s.open = false)). Resultado: al ir en diagonal desde
 * un item hacia sus tiles barres por encima de los vecinos y te cierran el panel a mitad de viaje.
 *
 * No se puede parchear _detectHover: el theme lo bindea en el constructor, así que la referencia
 * ya está capturada. En su lugar escuchamos en CAPTURA sobre la lista del nav (ancestro), que corre
 * ANTES del listener del theme, y frenamos la apertura instantánea de los items aún cerrados.
 * El cierre lo sigue gestionando el theme con su tolerancia de 500ms.
 */
(function () {
  var list = document.querySelector('.header__link-list');
  if (!list || list.dataset.mcIntent === 'on') return;
  list.dataset.mcIntent = 'on';

  var OPEN_INTENT_MS = 130;
  var timer = null;
  var pending = null;

  function cancel() {
    if (timer) clearTimeout(timer);
    timer = null;
    pending = null;
  }

  // B1 (31-oct-2026): el contenido de los paneles ya no va en el HTML de cada página (pesaba ~137 KB antes
  // del H1). Se pide la sección mc-mega-panels con la Section Rendering API, en el idioma de la URL, y se
  // copia cada panel en su carcasa [data-mc-panel]. La carcasa (.mega-menu--mc) se rellena por dentro y
  // nunca se sustituye: AnimatedDetails la tiene cacheada como contentElement (ver header.liquid).
  // Se pide en un momento libre tras la carga (solo escritorio) o, si aún no está, al primer hover, foco o
  // toque. En móvil el nav está display:none: no se pide nunca.
  // mcLoadPanels() resuelve true si las carcasas tienen contenido. Si la petición falla (red, error o
  // respuesta sin paneles), resuelve false y deja reintentar hasta 3 veces, con espera creciente.
  var panelsReq = null;
  var fallos = 0;
  var noAntesDe = 0;

  function filled() {
    var shells = list.querySelectorAll('[data-mc-panel]');
    for (var i = 0; i < shells.length; i++) if (!shells[i].childElementCount) return false;
    return shells.length > 0;
  }

  function mcLoadPanels() {
    if (filled()) return Promise.resolve(true);
    if (panelsReq) return panelsReq;
    if (fallos >= 3 || Date.now() < noAntesDe) return Promise.resolve(false);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || list.getAttribute('data-mc-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    panelsReq = fetch(root + '?section_id=mc-mega-panels', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('mc-mega-panels ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        list.querySelectorAll('[data-mc-panel]').forEach(function (shell) {
          if (shell.childElementCount) return;
          var src = doc.querySelector('[data-mc-panel-src="' + shell.getAttribute('data-mc-panel') + '"]');
          if (src) shell.append.apply(shell, Array.prototype.slice.call(src.childNodes));
        });
        if (!filled()) throw new Error('mc-mega-panels sin contenido');
        return true;
      })
      .catch(function () {
        fallos += 1;
        noAntesDe = Date.now() + 1000 * Math.pow(2, fallos); // 2, 4 y 8 s
        return false;
      })
      .then(function (ok) {
        panelsReq = null;
        return ok;
      });
    return panelsReq;
  }

  if (window.matchMedia('(min-width: 1150px)').matches) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2000); };
    var schedule = function () { idle(mcLoadPanels, { timeout: 4000 }); };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  // Foco por teclado y toque (en táctil el theme abre por clic): pedir los paneles antes de abrir.
  list.addEventListener('focusin', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('details[data-mc-lazy]')) mcLoadPanels();
  }, true);
  list.addEventListener('pointerdown', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('details[data-mc-lazy]')) mcLoadPanels();
  }, true);

  list.addEventListener('mouseover', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var det = target.closest('details');
    if (!det || !list.contains(det)) return;
    if (det.hasAttribute('data-mc-lazy')) mcLoadPanels(); // también si el theme abre por clic
    if (det.trigger !== 'hover') return;

    // Ya abierto: dejar pasar el evento tal cual, que el theme cancele su cierre pendiente.
    if (det.open) {
      cancel();
      return;
    }

    // Cerrado: bloquear la apertura instantánea del theme y exigir que el ratón se quede.
    event.stopPropagation();
    if (pending === det) return;
    cancel();
    pending = det;
    timer = setTimeout(function () {
      // Si los paneles aún no han llegado (hover antes del momento libre), se abre al llegar y no vacío.
      // Si no llegan (fallo), no se abre: el clic en la categoría sigue llevando a su página.
      var ready = det.hasAttribute('data-mc-lazy') ? mcLoadPanels() : Promise.resolve(true);
      ready.then(function (ok) {
        if (pending !== det) return; // el ratón ya se fue
        cancel();
        if (!ok) return;
        // Como bloqueamos su mouseover, el theme no cancela el cierre que dejó pendiente al salir antes:
        // sin esto, si sales y vuelves rápido, el panel se abre y se cierra solo a los ~250 ms.
        clearTimeout(det._hoverTimer);
        det.open = true;
      });
    }, OPEN_INTENT_MS);
  }, true);

  list.addEventListener('mouseout', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var det = target.closest('details');
    if (det && det === pending) cancel();
  }, true);
})();

(function () {
  if (customElements.get('mc-mega-tabs')) return;

  class McMegaTabs extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      var signal = this._ac.signal;

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;

      var self = this;
      // Hover CON INTENCIÓN. El hover a secas ya se probó y se descartó: para llegar a una tab
      // de abajo cruzas por encima de todas las de arriba y el grid iba cambiando por el camino.
      // Con el retardo, ir de paso no dispara nada; solo dispara si te quedas.
      var finePointer = window.matchMedia('(pointer: fine)').matches;

      this.tabs.forEach(function (tab) {
        // El clic sigue seleccionando al instante (accesibilidad + no esperar el retardo).
        tab.addEventListener('click', function () { self._cancelIntent(); self.select(self._indexOf(tab)); }, { signal: signal });
        tab.addEventListener('keydown', function (e) { self._onKeydown(e); }, { signal: signal });

        if (!finePointer) return; // en táctil, pointerenter dispara al tocar: solo clic

        tab.addEventListener('pointerenter', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          self._cancelIntent();
          self._intentTimer = setTimeout(function () { self.select(self._indexOf(tab)); }, self.hoverIntentDelay);
        }, { signal: signal });

        tab.addEventListener('pointerleave', function () { self._cancelIntent(); }, { signal: signal });
      });
    }

    get hoverIntentDelay() {
      return 140;
    }

    _cancelIntent() {
      if (this._intentTimer) {
        clearTimeout(this._intentTimer);
        this._intentTimer = null;
      }
    }

    _indexOf(tab) {
      var i = parseInt(tab.getAttribute('data-index'), 10);
      return isNaN(i) ? this.tabs.indexOf(tab) : i;
    }

    select(index) {
      this.tabs.forEach(function (tab) {
        var selected = this._indexOf(tab) === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      }, this);

      this.panels.forEach(function (panel) {
        var i = parseInt(panel.getAttribute('data-index'), 10);
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    _focusTab(index) {
      var target = this.tabs.filter(function (t) { return this._indexOf(t) === index; }, this)[0];
      if (target) {
        this.select(index);
        target.focus();
      }
    }

    _onKeydown(e) {
      var current = this.tabs.indexOf(document.activeElement);
      if (current === -1) return;
      var last = this.tabs.length - 1;
      var next = null;

      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          next = current === last ? 0 : current + 1;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          next = current === 0 ? last : current - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }

      e.preventDefault();
      this._focusTab(this._indexOf(this.tabs[next]));
    }

    disconnectedCallback() {
      this._cancelIntent();
      if (this._ac) this._ac.abort();
    }
  }

  customElements.define('mc-mega-tabs', McMegaTabs);
})();
